const SITE_TYPE_IOM = 0;
const SITE_TYPE_CO = 1;
const SITE_TYPE_NUTS = 2;


export default {
  SITE_TYPE_IOM,
  SITE_TYPE_CO,
  SITE_TYPE_NUTS,
  GetSiteType() {
    if (process.env.VUE_APP_PROJECT_NAME === 'NUTS') {
        return SITE_TYPE_NUTS;
    } else {
        return SITE_TYPE_IOM;
    }
    // if (process.env.PAGE === "nuts") {
    //   return SITE_TYPE_NUTS;
    // } else {
    //   switch (location.host) {
    //     case "beta10.kkpoker.co:9852":
    //     case "nutspoker.cc":
    //       return SITE_TYPE_NUTS;
    //     default:
    //       return SITE_TYPE_IOM;
    //   }
    // }
  },
};
